"use strict";
globalThis.Utils = (() => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const toggle = (el, cls, force) => el?.classList.toggle(cls, force);
  const hide = (el) => {
    if (!el) return;
    const showClass = el.dataset?.showClass;
    if (showClass) {
      showClass.split(" ").forEach((cls) => el.classList.remove(cls));
    }
    el.classList.add("hidden");
  };
  const show = (el) => {
    if (!el) return;
    el.classList.remove("hidden");
    const showClass = el.dataset?.showClass;
    if (showClass) {
      showClass.split(" ").forEach((cls) => el.classList.add(cls));
    }
  };
  const isHidden = (el) => el?.classList.contains("hidden");
  const clampInt = (val, min, max, fallback = 0) => {
    const n = Number.parseInt(val, 10);
    return Number.isNaN(n) ? fallback : Math.min(Math.max(n, min), max);
  };
  const formatCurrency = (n, locale = "nl-NL") => new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
  const debounce = (fn, ms) => {
    let id;
    return (...args) => {
      clearTimeout(id);
      id = setTimeout(() => fn(...args), ms);
    };
  };
  const throttle = (fn, ms) => {
    let last = 0;
    return (...args) => {
      const now = Date.now();
      if (now - last >= ms) {
        last = now;
        fn(...args);
      }
    };
  };
  const pipe = (...fns) => (x) => fns.reduce((v, f) => f(v), x);
  const parseJSON = (str, fallback = null) => {
    try {
      return JSON.parse(str);
    } catch {
      return fallback;
    }
  };
  const uid = () => `_${Math.random().toString(36).slice(2, 9)}`;
  const isMobile = () => globalThis.matchMedia("(max-width: 767px)").matches;
  const announce = (msg, el = $("#step-announcer")) => {
    if (el) el.textContent = msg;
  };
  const html = (str) => {
    const t = document.createElement("template");
    t.innerHTML = str.trim();
    return t.content.firstChild;
  };
  const attr = (el, name, fallback = "") => el?.getAttribute(name) ?? fallback;
  const data = (el, name, fallback = "") => el?.dataset?.[name] ?? fallback;
  const on = (parent, event, selector, handler, options) => {
    parent.addEventListener(event, (e) => {
      const target = e.target.closest(selector);
      if (target) handler(e, target);
    }, options);
  };
  const once = (el, event, handler) => el?.addEventListener(event, handler, { once: true });
  const getCsrfToken = () => {
    const meta = $('meta[name="csrf-token"]');
    return meta?.content || "";
  };
  const fetchWithCsrf = (url, options = {}) => {
    const token = getCsrfToken();
    const headers = new Headers(options.headers || {});
    if (token) {
      headers.set("X-CSRF-Token", token);
    }
    return fetch(url, { ...options, headers });
  };
  return Object.freeze({
    $,
    $$,
    toggle,
    hide,
    show,
    isHidden,
    clampInt,
    formatCurrency,
    debounce,
    throttle,
    pipe,
    parseJSON,
    uid,
    isMobile,
    announce,
    html,
    attr,
    data,
    on,
    once,
    getCsrfToken,
    fetchWithCsrf
  });
})();
